import { useSession } from '@/lib/auth-client'

/**
 * Session-aware primary CTA. Mirrors the Header: anonymous visitors are sent
 * to sign-up, signed-in users straight to their dashboard.
 */
export function useAccessCta() {
  const { data: session } = useSession()
  const signedIn = Boolean(session?.user)

  return signedIn
    ? ({ signedIn, to: '/dashboard', label: 'Open dashboard' } as const)
    : ({ signedIn, to: '/sign-up', label: 'Get a free API key' } as const)
}
